export function createElement(name) {
	return document.createElement(name);
}
export function getElement(id) {
	return document.getElementById(id);
}
/**
 * @param {string} query
 * @param {function(HTMLElement)} doWithEach
 * @return {NodeListOf<HTMLElement>}
 */
export function queryElements(query, doWithEach) {
	const selector = document.querySelectorAll(query);
	if (typeof doWithEach !== 'undefined') {
		selector.forEach(doWithEach);
	}
	return selector;
}
export function appendElementToBody(element) {
	document.body.appendChild(element);
}
export function showElement(element) {
	element.style.display = 'block';
}
export function hideElement(element) {
	element.style.display = 'none';
}
export function setHtml(element, content) {
	element.innerHTML = content;
}
export function setText(element, content) {
	element.textContent = content;
}
export function shuffleArray(array) {
	let tmp, randomKey, i = array.length;
	while (--i) {
		randomKey = Math.floor(Math.random() * (i + 1));
		tmp = array[randomKey];
		array[randomKey] = array[i];
		array[i] = tmp;
	}
}
export function loadJs(url) {
	const s = createElement('script');
	s.src = url;
	appendElementToBody(s);
}
export function getCountryParts(value) {
	const end = value.substring(2, 3) === '-' ? 6 : 2;
	return {o: value, c: value.substring(0, end), n: value.substring(end)};
}
export function onClick(el, callback) {
	el.addEventListener('click', callback);
}


export function getCookie(cname) {
	let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	if (ca && ca.length > 0) {
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
	}
	return "";
}
export function setCookie(key, value, seconds) {
	const cookieExpiration = new Date();
	cookieExpiration.setTime(cookieExpiration.getTime() + ((seconds || 31536000) * 1000)); // 31536000 = year in seconds
	document.cookie = key + '=' + value + '; expires=' + cookieExpiration.toUTCString() + '; path=/';
}


export function disableSubmit(submitBtn) {
	submitBtn.prop('disabled', true);

	return setTimeout(function() {
		enableSubmit(submitBtn)
	}, 10000);
}

export function disableVanillaSubmit(submitBtn) {
	submitBtn.disabled = true;

	return setTimeout(function() {
		enableVanillaSubmit(submitBtn);
	}, 10000);
}

export function enableSubmit(submitBtn, submitDisableTimeout = null) {

	if (submitDisableTimeout) {
		clearTimeout(submitDisableTimeout);
	}

	submitBtn.prop('disabled', false);
}

export function enableVanillaSubmit(submitBtn, submitDisableTimeout = null) {

	if (submitDisableTimeout) {
		clearTimeout(submitDisableTimeout);
	}

	submitBtn.disabled = false;
}
